export const dates = ["06", "05", "2025"];
